import { render, staticRenderFns } from "./FlexRoute.vue?vue&type=template&id=40e3d381"
import script from "./FlexRoute.vue?vue&type=script&lang=js"
export * from "./FlexRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports